import { Store } from 'redux';
import { LoaderFunction, redirect } from 'react-router-dom';

import { getIsAuthenticated } from 'ha/modules/AuthLogic/selectors';
import { HttpStatus } from 'ha/constants/HttpStatus';

export const authenticated =
  (store: Store): LoaderFunction =>
  () => {
    if (getIsAuthenticated(store.getState())) {
      //eslint-disable-next-line @typescript-eslint/no-throw-literal
      throw redirect('/my', HttpStatus.FOUND_REDIRECTION);
    }

    return null;
  };
